import { Avatar, Dropdown, Typography } from "antd"
import React from "react"
import { ReactComponent as LogoutIcon } from "assets/icons/logout.svg"
import { ReactComponent as LanguageIcon } from "assets/icons/language.svg"
import { ReactComponent as ProfileIcon } from "assets/icons/profile.svg"
import FrenchIcon from "assets/french.png"
import EnglishIcon from "assets/english.png"
import userAvatar from "assets/user.jpg"
import styles from "./styles.module.scss"
import classNames from "classnames"
import { useAuth, useLogout } from "providers/auth"
import { useTranslation } from "react-i18next"
import useLanguage from "./use-change-language"
import { useNavigate } from "react-router-dom"
const { Text } = Typography
const UserSettings: React.FC = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const onLogout = useLogout()
  const { t } = useTranslation()
  const { onChange, language } = useLanguage()
  const onProfileClick = () => navigate("/user/profile")
  return (
    <Dropdown
      trigger={["click"]}
      overlayStyle={{ width: 150 }}
      menu={{
        selectable: true,
        selectedKeys: [language],
        items: [
          {
            key: "1",
            label: <Text>{user?.name}</Text>,
            icon: <Avatar src={user?.avatarThumb || userAvatar} size="small" />,
            onClick: onProfileClick,
          },
          { type: "divider" },
          {
            key: "2",
            label: <Text>{t("global.language")}</Text>,
            icon: <LanguageIcon />,
            children: [
              {
                key: "fr",
                label: t("global.french"),
                icon: (
                  <img
                    src={FrenchIcon}
                    alt={t("global.french")}
                    className={styles.icon}
                  />
                ),
                onClick: () => onChange("fr"),
              },
              {
                key: "en",
                label: t("global.english"),
                onClick: () => onChange("en"),
                icon: (
                  <img
                    src={EnglishIcon}
                    alt={t("global.english")}
                    className={styles.icon}
                  />
                ),
              },
            ],
          },
          {
            key: "3",
            label: <Text>{t("profile.profile")}</Text>,
            onClick: onProfileClick,
            icon: <ProfileIcon />,
          },
          { type: "divider" },
          {
            key: "4",
            label: <Text className={styles.logout}>{t("logout")}</Text>,
            icon: <LogoutIcon className={styles.logout} />,
            onClick: onLogout,
          },
        ],
      }}
      placement="bottomRight"
    >
      <div onClick={(e) => e.preventDefault()} className={styles.userSection}>
        <div>
          <div className={classNames(styles.name, "body-heavy")}>
            {user?.name}
          </div>
          <div className={classNames(styles.username, "caption")}>
            @{user?.username}
          </div>
        </div>
        <Avatar src={user?.avatarThumb || userAvatar} size="large" />
      </div>
    </Dropdown>
  )
}
export default UserSettings
